module.exports = __webpack_public_path__ + "static/media/MapPicture.e914c3bb.JPG";